PJQ.views.primeContracts.PrimeContractManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contract-management'),
        subTemplates: {
            primeContractTotals: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contract-management-totals'),
            invoiceTotals: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management-totals')
        },
        primeContractId: null,
        changeOrderId: null,
        invoiceId: null,
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
        'click .btn-settings': 'settings'
    },
    beforeFirstRender: function () {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');
        this.options.canViewChangeOrders = PJQ.app.session.project.hasPermission('primeContractChangeOrders.canView');
        this.options.canViewInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.canView');
        this.options.canViewChangeRequests = PJQ.app.session.project.hasPermission('changeRequests.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContracts.isAdmin')
            && PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin');
    },
    renderData: function () {
        return {
            primeContracts: this.primeContracts,
            changeOrders: this.changeOrders,
            invoices: this.invoices,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            isAdmin: this.options.isAdmin,
            canViewChangeRequests: this.options.canViewChangeRequests
        }
    },
    afterRender: function () {
        this.primeContractsView = null;
        this.changeOrdersView = null;
        this.invoicesView = null;
        this.changeRequestsView = null;

        this.renderStats();
        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.commitmentId > 0 && this.options.canViewPrimeContracts) {
            this.activateTab('primecontracts');
        } else if (this.options.changeOrderId > 0 && this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.invoiceId > 0 && this.options.canViewInvoices) {
            this.activateTab('invoices');
        } else if (this.options.changeRequestId > 0 && this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        } else if (this.options.canViewPrimeContracts) {
            this.activateTab('primecontracts');
        } else if (this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.canViewInvoices) {
            this.activateTab('invoices');
        } else if (this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        }
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        switch (this.activeView) {
            case 'changeorders':
                if (this.changeOrdersView == null || this.changeOrdersView.collection == null || !this.changeOrdersView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeOrdersView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.primeContractTotals, $totals, {
                    pending: totals[PJQ.constants.primeContracts.changeOrderStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.primeContracts.changeOrderStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.primeContracts.changeOrderStatusBuckets.APPROVED.name]
                });
                break;
            case 'changerequests':
                if (this.changeRequestsView == null || this.changeRequestsView.collection == null || !this.changeRequestsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeRequestsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.primeContractTotals, $totals, {
                    pending: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.APPROVED.name]
                });
                break;
            case 'invoices':
                if (this.invoicesView == null || this.invoicesView.collection == null || !this.invoicesView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.invoicesView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.invoiceTotals, $totals, {
                    draft: totals[PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT],
                    reviewing: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVIEWING],
                    approved: totals[PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED],
                    complete: totals[PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE],
                    revise: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVISE]
                });
                break;
            default:
                if (this.primeContractsView == null || this.primeContractsView.collection == null || !this.primeContractsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.primeContractsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.primeContractTotals, $totals, {
                    pending: totals[PJQ.constants.primeContracts.primeContractStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.primeContracts.primeContractStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.primeContracts.primeContractStatusBuckets.APPROVED.name]
                });
                break;
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;

        switch (tab ? tab.toLowerCase() : null) {
            case 'changeorders':
                tab = 'PCCO_List';
                this.renderChangeOrdersView();
                break;
            case 'invoices':
                tab = 'RI_List';
                this.renderInvoicesView();
                break;
            case 'changerequests':
                tab = 'CR_List';
                this.renderChangeRequestsView();
                break;
            default:
                tab = 'PC_List';
                this.renderPrimeContractsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;

        this.renderStats();
    },
    tabActivated: function (e) {
        if (this.isActivating) {
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#PC_List':
                vw = 'contracts';
                break;
            case '#PCCO_List':
                vw = 'changeorders';
                break;
            case '#CR_List':
                vw = 'changerequests';
                break;
            case '#RI_List':
                vw = 'invoices';
                break;
        }
        this.activateTab(vw);
    },
    renderPrimeContractsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts', {
            trigger: false
        });
        if (this.primeContractsView == null && this.options.canViewPrimeContracts) {
            let fnRender = _.bind(function () {
                this.primeContractsView = new PJQ.views.primeContracts.PrimeContractsList({
                    el: this.$('.prime-contracts-pane'),
                    project: PJQ.app.session.project,
                    primeContractId: this.options.primeContractId,
                    collection: this.primeContracts,
                    afterRender: _.bind(this.renderStats, this),
                    onChange: _.bind(function () {
                        this.renderStats();
                    }, this),
                    onChangeOrderAdd: _.bind(function (changeOrder) {
                        if (this.changeOrders != null) {
                            this.changeOrders.add(changeOrder);

                            if (this.changeOrdersView != null) {
                                this.changeOrdersView.render();
                            }
                        }
                        this.renderStats();
                    }, this),
                    onInvoiceAdd: _.bind(function (invoice) {
                        if (this.invoices != null) {
                            this.invoices.add(invoice);

                            if (this.invoicesView != null) {
                                this.invoicesView.render();
                            }
                        }
                    }, this)
                });
                this.options.primeContractId = null;
            }, this)

            if (this.primeContracts == null) {
                this.primeContracts = new PJQ.collections.primeContracts.PrimeContracts(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.primeContracts.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChangeOrdersView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts/changeorders', {
            trigger: false
        });
        if (this.changeOrdersView == null && this.options.canViewChangeOrders) {
            let fnRender = _.bind(function () {
                this.changeOrdersView = new PJQ.views.primeContracts.ChangeOrdersList({
                    el: this.$('.change-orders-pane'),
                    project: PJQ.app.session.project,
                    changeOrderId: this.options.changeOrderId,
                    collection: this.changeOrders,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.changeOrderId = null;
            }, this);

            if (this.changeOrders == null) {
                this.changeOrders = new PJQ.collections.primeContracts.ChangeOrders(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeOrders.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChangeRequestsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts/changerequests', {
            trigger: false
        });

        if (this.changeRequestsView == null && this.options.canViewChangeRequests) {
            let fnRender = () => {
                this.changeRequestsView = new PJQ.views.changeRequests.ChangeRequestsList({
                    el: this.$('.change-requests-pane'),
                    project: PJQ.app.session.project,
                    changeRequestId: this.options.changeRequestId,
                    collection: this.changeRequests,
                    hideHeader: true,
                    afterRender: () => this.renderStats(),
                });
                this.options.changeRequestId = null;
            };

            if (this.changeRequests == null) {
                this.changeRequests = new PJQ.collections.changeRequests.ChangeRequests(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeRequests.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/contracts/invoices', {
            trigger: false
        });
        if (this.invoicesView == null && this.options.canViewInvoices) {
            let fnRender = () => {
                this.invoicesView = new PJQ.views.invoicing.ReceivableInvoicesList({
                    el: this.$('.invoices-pane'),
                    project: PJQ.app.session.project,
                    invoiceId: this.options.invoiceId,
                    collection: this.invoices,
                    afterRender: _.bind(this.renderStats, this),
                    onDelete: _.bind(function (invoice) {
                        this.invoices.remove(invoice);
                    }, this)
                });
                this.options.invoiceId = null;
            }

            if (this.invoices == null) {
                this.invoices = new PJQ.collections.invoicing.ReceivableInvoices(null, {
                    project: this.options.project
                });
                this.invoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#PC_List':
                if (this.primeContractsView != null) {
                    this.primeContractsView.editSettings();
                }
                break;
            case '#PCCO_List':
                if (this.changeOrdersView != null) {
                    this.changeOrdersView.editSettings();
                }
                break;
            case '#CR_List':
                if (this.changeRequestsView != null) {
                    this.changeRequestsView.editSettings();
                }
                break;
            case '#RI_List':
                if (this.invoicesView != null) {
                    this.invoicesView.editSettings();
                }
                break;
        }
    },
    updateTotalsCount: function () {
        let $primeContractSpan = this.$('.prime-contracts-total'),
            $changeOrdersSpan = this.$('.change-orders-total'),
            $changeRequestsSpan = this.$('.change-requests-total'),
            $invoiceSpan = this.$('.invoices-total');
        $primeContractSpan.text(_.size(this.primeContracts.models));
        $changeOrdersSpan.text(_.size(this.changeOrders.models));
        $changeRequestsSpan.text(_.size(this.changeRequests.models));
        $invoiceSpan.text(_.size(this.invoices.models));
    }
});